import React from 'react';
import Baumumfang from '../components/Baumumfang';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BaumumfangKlausenLeopoldsdorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="baumumfang-klausen-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="baumumfang-klausen-heading">BAUMUMFANG</h1>
        </div>

        <Baumumfang ort="klausen-Leopoldsdorf" />
      </div>
    </div>
  );
}

export default BaumumfangKlausenLeopoldsdorf;
